import { render, staticRenderFns } from "./verificationList.vue?vue&type=template&id=3b01784b&scoped=true"
import script from "./verificationList.vue?vue&type=script&lang=js"
export * from "./verificationList.vue?vue&type=script&lang=js"
import style0 from "./verificationList.vue?vue&type=style&index=0&id=3b01784b&prod&lang=less&scoped=true"
import style1 from "./verificationList.vue?vue&type=style&index=1&id=3b01784b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b01784b",
  null
  
)

export default component.exports